var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cTable',{attrs:{"apis":_vm.methods,"tm":""}})}
var staticRenderFns = []

export { render, staticRenderFns }